module.exports = "https://static.wmbcdn.com/uniweb/images/5c76bc55a79d97bad4c532ade0deb5a7.svg";